import type { CSSObject } from '@emotion/react';

export const rootStyles: CSSObject = {
  minHeight: '100vh',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '24px',
  backgroundColor: '#f5f7fb',
};

export const cardStyles: CSSObject = {
  width: '100%',
  maxWidth: '480px',
  padding: '32px',
  borderRadius: '16px',
  backgroundColor: '#ffffff',
  boxShadow: '0 16px 40px rgba(15, 23, 42, 0.08)',
  textAlign: 'center',
};

export const titleStyles: CSSObject = {
  margin: 0,
  color: '#101828',
  fontSize: '28px',
  fontWeight: 600,
  lineHeight: 1.2,
};

export const descriptionStyles: CSSObject = {
  margin: '12px 0 0',
  color: '#475467',
  fontSize: '16px',
  lineHeight: 1.5,
};

export const actionsStyles: CSSObject = {
  marginTop: '24px',
  display: 'flex',
  justifyContent: 'center',
};
